import {
  AssignedAttendant,
  AttendantRead,
} from 'src/common/external/bambi-api/bambiApi';

export const convertAttendantsToAssignedAttendants = (
  attendants: AttendantRead[]
): AssignedAttendant[] => {
  return attendants.map((x) => ({
    attendant: x.id,
  }));
};
